exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.has-error .editor {\r\n  border: 1px solid #f5222d;\n}\r\n", ""]);

// exports
